import './main.css';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/free-mode';

// Make Swiper available globally
window.Swiper = Swiper;

// Carousel image error handling function
async function processCarouselImageError(img) {
  console.log("processCarouselImageError", img);

  // Set fallback placeholder image first
  const placeholderImage =
    "/wp-content/themes/wp-theme-urlaubsfritzen-classic/assets/placeholder.png";
  img.src = placeholderImage;

  // Prevent infinite reprocessing
  if (img.dataset.imgChecked === "true") {
    console.log("Image already processed, skipping.");
    return;
  }

  // Mark image as processed
  img.dataset.imgChecked = "true";

  const id = img.dataset.id;
  if (!id) {
    console.warn("No data-id found on image.");
    return;
  }

  try {
    const response = await fetch(
      `/wp-json/urlaubsfritzen/v1/google_image?id=${id}`
    );
    const data = await response.json();
    if (data.image) {
      img.src = data.image;
    }
  } catch (error) {
    console.error("Error fetching image:", error);
  }
}

// Make the function globally available
window.processCarouselImageError = processCarouselImageError;

// Initialize hero carousel
window.addEventListener('load', () => {
    console.log('Window load event fired');
    // Wait a bit to ensure all resources are loaded
    setTimeout(() => {
        console.log('Timeout callback running');
        const swiperElement = document.querySelector('.hero-swiper');
        console.log('Swiper element:', swiperElement);
        if (swiperElement) {
            const heroSwiper = new Swiper('.hero-swiper', {
                modules: [Navigation, Pagination, Autoplay, EffectFade],
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
            console.log('Swiper initialized:', heroSwiper);
        } else {
            console.warn('Hero swiper element not found');
        }

        // Initialize Product Carousels
        initializeProductCarousels();

        // Initialize Hotel Image Carousels
        initializeHotelImageCarousels();

        // Initialize Main Image Swipers
        initializeMainImageSwipers();

        // Add event listener for mobile menu button
        const mobileMenuButton = document.querySelector('.mobile-menu-button');
        const mobileMenuClose = document.querySelector('.mobile-menu-close');
        const mobileMenu = document.querySelector('.mobile-menu');
        const hamburgerIcon = document.querySelector('.hamburger-icon');
        const closeIcon = document.querySelector('.close-icon');

        function toggleMobileMenu() {
            mobileMenu.classList.toggle('hidden');
            hamburgerIcon.classList.toggle('hidden');
            closeIcon.classList.toggle('hidden');
            document.body.classList.toggle('overflow-hidden');
        }

        if (mobileMenuButton && mobileMenu) {
            mobileMenuButton.addEventListener('click', toggleMobileMenu);
        }

        if (mobileMenuClose && mobileMenu) {
            mobileMenuClose.addEventListener('click', toggleMobileMenu);
        }

    }, 100);
});

function initializeHotelImageCarousels() {
    const hotelCarousels = document.querySelectorAll('.hotel-images-swiper');
    if (hotelCarousels.length === 0) {
        console.log('No hotel image carousels found to initialize.');
        return;
    }
    console.log(`Found ${hotelCarousels.length} hotel image carousel(s).`);

    hotelCarousels.forEach((carouselElement, index) => {
        // Skip if already initialized
        if (carouselElement.swiper) {
            console.log(`Hotel carousel ${index + 1} already initialized, skipping.`);
            return;
        }

        const imageCount = carouselElement.querySelectorAll('.swiper-slide').length;
        console.log(`Hotel carousel ${index + 1} has ${imageCount} images.`);

        try {
            const swiper = new Swiper(carouselElement, {
                modules: [Navigation, FreeMode],
                slidesPerView: 'auto',
                spaceBetween: 8,
                freeMode: false,
                loop: false,
                initialSlide: 0, // Ensure first slide is active
                navigation: {
                    nextEl: carouselElement.querySelector('.swiper-button-next'),
                    prevEl: carouselElement.querySelector('.swiper-button-prev'),
                },
                on: {
                    init: function() {
                        console.log(`Hotel carousel ${index + 1} initialized successfully.`);
                        // Ensure first thumbnail is active
                        const firstSlide = carouselElement.querySelector('.swiper-slide');
                        if (firstSlide) {
                            firstSlide.classList.add('border-2', 'border-primary-600');
                        }
                    },
                    slideChange: function() {
                        console.log(`Hotel carousel ${index + 1} slide changed to: ${this.activeIndex}`);
                    }
                }
            });
        } catch (e) {
            console.error(`Error initializing hotel image carousel ${index + 1}:`, e);
        }
    });
}

function initializeMainImageSwipers() {
    const mainImageSwipers = document.querySelectorAll('.main-image-swiper');
    if (mainImageSwipers.length === 0) {
        console.log('No main image swipers found to initialize.');
        return;
    }
    console.log(`Found ${mainImageSwipers.length} main image swiper(s).`);

    mainImageSwipers.forEach((swiperElement, index) => {
        // Skip if already initialized
        if (swiperElement.swiper) {
            console.log(`Main image swiper ${index + 1} already initialized, skipping.`);
            return;
        }

        const imageCount = swiperElement.querySelectorAll('.swiper-slide').length;
        console.log(`Main image swiper ${index + 1} has ${imageCount} images.`);

        if (imageCount <= 1) {
            console.log(`Main image swiper ${index + 1} has only ${imageCount} image, skipping initialization.`);
            return;
        }

        try {
            const swiper = new Swiper(swiperElement, {
                modules: [Navigation, EffectFade],
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                initialSlide: 0, // Ensure first slide is active
                navigation: {
                    nextEl: swiperElement.querySelector('.swiper-button-next'),
                    prevEl: swiperElement.querySelector('.swiper-button-prev'),
                },
                on: {
                    init: function() {
                        console.log(`Main image swiper ${index + 1} initialized successfully.`);
                        // Ensure thumbnail carousel is synced on initialization
                        updateThumbnailCarousel(0, index);
                    },
                    slideChange: function() {
                        console.log(`Main image swiper ${index + 1} slide changed to: ${this.activeIndex}`);
                        // Update the thumbnail carousel to sync with main image
                        updateThumbnailCarousel(this.activeIndex, index);
                    }
                }
            });
        } catch (e) {
            console.error(`Error initializing main image swiper ${index + 1}:`, e);
        }
    });
}

function updateThumbnailCarousel(activeIndex, swiperIndex) {
    // Find all main image swipers and get the corresponding thumbnail carousel
    const mainImageSwipers = document.querySelectorAll('.main-image-swiper');
    const mainImageSwiper = mainImageSwipers[swiperIndex];
    
    if (mainImageSwiper) {
        // Find the thumbnail carousel that's in the same container as this main image swiper
        const container = mainImageSwiper.closest('.relative.overflow-hidden.flex.flex-col.gap-4');
        const thumbnailCarousel = container ? container.querySelector('.hotel-images-swiper') : null;
        
        if (thumbnailCarousel) {
            const thumbnailSwiper = thumbnailCarousel.swiper;
            if (thumbnailSwiper) {
                // Update the active thumbnail
                const thumbnailSlides = thumbnailCarousel.querySelectorAll('.swiper-slide');
                thumbnailSlides.forEach((slide, index) => {
                    slide.classList.remove('border-2', 'border-primary-600');
                    if (index === activeIndex) {
                        slide.classList.add('border-2', 'border-primary-600');
                    }
                });
                
                // Scroll to the active thumbnail if needed
                thumbnailSwiper.slideTo(activeIndex);
            } else {
                // If swiper is not initialized yet, just update the classes
                const thumbnailSlides = thumbnailCarousel.querySelectorAll('.swiper-slide');
                thumbnailSlides.forEach((slide, index) => {
                    slide.classList.remove('border-2', 'border-primary-600');
                    if (index === activeIndex) {
                        slide.classList.add('border-2', 'border-primary-600');
                    }
                });
            }
        }
    }
}

function initializeProductCarousels() {
    const productCarousels = document.querySelectorAll('.fz-products-swiper-container');
    if (productCarousels.length === 0) {
        // console.log('No product carousels found to initialize.');
        return;
    }
    console.log(`Found ${productCarousels.length} product carousel(s).`);

    productCarousels.forEach((carouselElement, index) => {
        const carouselId = carouselElement.dataset.carouselId || `fz-product-carousel-${index}`;
        const loop = carouselElement.dataset.loop === 'true';
        const autoplayDelay = parseInt(carouselElement.dataset.autoplayDelay, 10) || 1;
        const autoplaySpeed = parseInt(carouselElement.dataset.autoplaySpeed, 10) || 2000;

        // 2xs is a custom break point
        const breakpoints = {};
        const sizes = { xs: 0, 'base': 380, sm: 640, md: 768, lg: 1024, xl: 1280 }; // Tailwind breakpoints

        const { baseSlidesPerView, baseSpaceBetween } = updateCarouselSettings(carouselElement);

        for (const [sizeKey, breakpointValue] of Object.entries(sizes)) {
            if (sizeKey === 'xs' || sizeKey === 'base') continue; // Skip 'xs' and 'base' for breakpoints object, handled as base

            const slidesPerView = carouselElement.dataset[`slidesPerView${sizeKey.charAt(0).toUpperCase() + sizeKey.slice(1)}`];
            const spaceBetween = carouselElement.dataset[`spaceBetween${sizeKey.charAt(0).toUpperCase() + sizeKey.slice(1)}`];

            if (slidesPerView) {
                breakpoints[breakpointValue] = {
                    slidesPerView: parseInt(slidesPerView, 10),
                    spaceBetween: parseInt(spaceBetween, 10) || 10
                };
            }
        }

        console.log('baseSlidesPerView', baseSlidesPerView);

        try {
            const swiper = new Swiper(carouselElement, {
                modules: [Autoplay], // Only Autoplay module needed for continuous scroll
                loop: loop,
                slidesPerView: baseSlidesPerView,
                spaceBetween: baseSpaceBetween,
                autoplay: {
                    delay: autoplayDelay,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                speed: autoplaySpeed,
                watchOverflow: true, 
                grabCursor: true,
                breakpoints: breakpoints,
            });
            console.log(`Product carousel '${carouselId}' initialized successfully.`);
        } catch (e) {
            console.error(`Error initializing Swiper for carousel '${carouselId}':`, e);
        }
    });
}

function updateCarouselSettings(carouselElement) {

    console.log('updateCarouselSettings', carouselElement.dataset);
    const screenSize = window.innerWidth;
    let baseSlidesPerView = 1.25;
    let baseSpaceBetween = 10;

    if (screenSize < 380) { // base
        baseSlidesPerView = parseFloat(carouselElement.dataset.slidesPerViewXs, 10) || baseSlidesPerView;
        baseSpaceBetween = parseInt(carouselElement.dataset.spaceBetweenXs, 10) || baseSpaceBetween;
    } else if (screenSize < 576) { // XS
        baseSlidesPerView = parseFloat(carouselElement.dataset.slidesPerViewBase, 10) || baseSlidesPerView;
        baseSpaceBetween = parseInt(carouselElement.dataset.spaceBetweenBase, 10) || baseSpaceBetween;
    } else if (screenSize < 640) { // SM
        baseSlidesPerView = parseFloat(carouselElement.dataset.slidesPerViewSm, 10) || baseSlidesPerView;
        baseSpaceBetween = parseInt(carouselElement.dataset.spaceBetweenSm, 10) || baseSpaceBetween;
    } else if (screenSize < 768) { // MD
        baseSlidesPerView = parseFloat(carouselElement.dataset.slidesPerViewSm, 10) || baseSlidesPerView;
        baseSpaceBetween = parseInt(carouselElement.dataset.spaceBetweenSm, 10) || baseSpaceBetween;
    } else if (screenSize < 992) { // MD
        baseSlidesPerView = parseFloat(carouselElement.dataset.slidesPerViewMd, 10) || baseSlidesPerView;
        baseSpaceBetween = parseInt(carouselElement.dataset.spaceBetweenMd, 10) || baseSpaceBetween;
    } else if (screenSize < 1200) { // LG
        baseSlidesPerView = parseFloat(carouselElement.dataset.slidesPerViewLg, 10) || baseSlidesPerView;
        baseSpaceBetween = parseInt(carouselElement.dataset.spaceBetweenLg, 10) || baseSpaceBetween;
    } else if (screenSize < 1280) { // XL
        baseSlidesPerView = parseFloat(carouselElement.dataset.slidesPerViewXl, 10) || baseSlidesPerView;
        baseSpaceBetween = parseInt(carouselElement.dataset.spaceBetweenXl, 10) || baseSpaceBetween;
    } else { // Default to the largest size
        baseSlidesPerView = parseFloat(carouselElement.dataset.slidesPerViewXl, 10) || baseSlidesPerView;
        baseSpaceBetween = parseInt(carouselElement.dataset.spaceBetweenXl, 10) || baseSpaceBetween;
    }

    return { baseSlidesPerView, baseSpaceBetween };
}

// Call this function whenever the screen size changes
window.addEventListener('resize', () => {
    const productCarousels = document.querySelectorAll('.fz-products-swiper-container');
    productCarousels.forEach((carouselElement) => {
        const { baseSlidesPerView, baseSpaceBetween } = updateCarouselSettings(carouselElement);
        carouselElement.dataset.slidesPerView = baseSlidesPerView;
        carouselElement.dataset.spaceBetween = baseSpaceBetween;
    });
});
